<template>
  <div>
    <section class='introDonate .text-grey-800'>
      <div class='introDescriptionDonate text-grey-800'
           data-aos="zoom-in"
           data-aos-duration="1500"
           data-aos-delay='250'>
        <div class="container">
          <p>
            <i class="fas fa-heart"></i>
            Support CitSci
          </p>
        </div>
      </div>
    </section>

    <div class="container pb-0" data-aos="fade-up">
      <h2>Student Software Developer Fundraising Campaign</h2>
      <p>
        Help us mentor the next generation of student software developers who want to use their
        programming skills to make a positive difference in the world!
      </p>
      <p>
        We're setting a goal to raise $10,000 to bring new undergraduate and graduate students
        into the CitSci team. CitSci students learn about participatory science and hone their
        software development skills, while working alongside experienced software developers to
        make your projects even better.<br>
        <b-link :to="{ name: 'Impact' }" target="_blank" rel="noopener noreferrer">
          Former CitSci students
        </b-link>
        have gone on to careers with non-profits, government, and industry, bringing with them
        valuable teamwork, problem-solving, and public engagement skills they couldn't have
        developed in the classroom alone.
      </p>
      <p>
        Give a gift of $10, $20 or more to provide a meaningful work and learning experience to a
        student this year with the Student Software Developer Campaign. You may just find these
        students working for you one day too!
      </p>
      <div class="mx-auto w-25 text-center">
        <DonateButton></DonateButton>
      </div>
    </div>
    <div class="container pb-0" data-aos="fade-up">
      <h2>Help keep participatory science free</h2>
      <h4>Did you know CitSci is 100% funded by grants and donations?</h4>
      <p>
        CitSci is made possible through grants, foundation support and generous donations from
        people like you. CitSci is free for project managers, participants, and everyone to use.
        We work closely with project managers to learn what new features would help them the most,
        and we add new features on a regular basis. Your donations help us dedicate more resources
        toward building our platform and mobile apps, helping project managers, and keeping CitSci
        free for everyone.
      </p>
      <p>
        All our free features - including project and data hosting, web tools, web support, apps,
        webinars, and tutorials - rely on the financial support of our supporters. We listen to your
        input and feedback and are constantly upgrading and expanding our participatory science
        support services.
      </p>
    </div>
    <div class="container pb-0" data-aos="fade-up">
      <h2>Help us help you</h2>
      <p>
        We empower everyone to do great science by providing quality web tools and apps to increase
        the rigor and usefulness of participatory science data. CitSci is a project of the
        <b-link href="https://www.nrel.colostate.edu/" target="_blank" rel="noopener noreferrer">Natural Resource
          Ecology
          Laboratory
        </b-link>
        <i class="fas fa-external-link-alt fa-xs"></i> at
        <b-link href="https://www.colostate.edu/" target="_blank" rel="noopener noreferrer">
          Colorado State University
        </b-link>
        <i class="fas fa-external-link-alt fa-xs"></i> in the
        <b-link href="https://warnercnr.colostate.edu/" target="_blank" rel="noopener noreferrer">
          Warner College of Natural Resources
        </b-link>
        <i class="fas fa-external-link-alt fa-xs"></i>.
      </p>
      <p>
        By supporting CitSci, you are helping make people-powered science possible!
      </p>
      <p>
        Want to help us help you and your communities?
      </p>
      <p>
        Please consider making a tax-deductible donation today.
      </p>

      <div class="mx-auto w-25 text-center mb-5">
        <DonateButton></DonateButton>
      </div>

    </div>
  </div>

</template>

<script>
import DonateButton from "./DonateButton.vue"

export default {
  components: {
    DonateButton
  },
}
</script>

<style lang="scss" scoped>
.introDonate {
  display: flex;
  background: grey;
  justify-content: space-evenly;
  padding-top: 20px;
  height: 400px;
  background-image: url('/assets/images/Donate-Banner.png');
  background-size: cover;
}

.introDescriptionDonate {
  font-size: 30px;
  padding-top: 120px;
}

.introDescriptionDonate p {
  font-size: 60px;
  font-weight: 900;
}
</style>
